import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastProvider } from "@radix-ui/react-toast";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { useI18N } from "@sundae/react-hooks";
import { Text } from "@sundae/ui-toolkit";
import WalletProvider from "@sundae/wallet-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import Button from "./components/Button/Button.js";
import ErrorFallback from "./components/ErrorFallback/ErrorFallback.js";
import LoadingComponent from "./components/LoadingComponent/index.js";
import { ClientRoutes } from "./routes/routes.js";
import { AppContextProvider } from "./stores/AppContext/context.js";
import { ProfileAppContextProvider } from "./stores/index.js";
const LazyDialogs = lazy(() => import("./components/Dialogs/index.js"));
const queryClient = new QueryClient();
const options = {
    debug: window.__APP_CONFIG.envName === "local",
    useHandles: false,
};
const FallbackComponent = ({ error, resetErrorBoundary, }) => {
    return (_jsxs("div", { className: "grid gap-2 p-2", role: "alert", children: [_jsx(Text, { tag: "div", size: "lg", children: "Something went wrong:" }), _jsx(Text, { tag: "div", children: error.message }), _jsx(Button, { onClick: resetErrorBoundary, className: "w-fit", children: "Try again" })] }));
};
const Providers = ({ children }) => {
    const { t } = useI18N();
    return (_jsx(HelmetProvider, { children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(WalletProvider, { options: options, children: _jsx(TooltipProvider, { delayDuration: 300, children: _jsx(ToastProvider, { label: t("notifications"), children: _jsx(ProfileAppContextProvider, { children: children }) }) }) }), _jsx(ReactQueryDevtools, { position: "bottom-left" })] }) }));
};
export const ClientProvider = (clientSettings) => {
    return (_jsx(AppContextProvider, { clientSettings: clientSettings, children: _jsxs(Providers, { ...clientSettings, children: [_jsx(Suspense, { fallback: _jsx(LoadingComponent, {}), children: _jsx(ErrorBoundary, { FallbackComponent: (props) => (_jsx(ErrorBoundary, { FallbackComponent: FallbackComponent, children: _jsx(ErrorFallback, { ...props }) })), children: _jsx(ClientRoutes, {}) }) }), _jsx(LazyDialogs, {})] }) }));
};
export default ClientProvider;
//# sourceMappingURL=ClientProvider.js.map